import {Question} from './underwriter.model';

export class QuestionGroups {
  group_type: string;
  group_name: string;
  class_id: number;
  item_id: string;
  questions: Question[] = [];
}
